
import {
  changeCashStatus
} from '@/api/order/cashOrder'
import { setOrderStatusRules } from '@/utils/rules'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { AppModule } from '@/store/modules/app'
@Component({
  name: 'payOutReject',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private info!: any

  get language () {
    return AppModule.language
  }

  private statusList: any[] = []
  private setForm: any = {
    status: null,
    remarks: '',
    description: '',
    google_code: ''
  }
  private rules = setOrderStatusRules
  private loading: boolean = false

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr () {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back () {
    this.setForm = {
      status: null,
      remarks: '',
      description: '',
      google_code: ''
    }
    this.$emit('close')
  }

  private async rejectPay () {
    (this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        this.flag = true
        const data: any = {
          ordernumber: this.info.ordernumber,
          ...this.setForm
        }
        try {
          await changeCashStatus(data).then(() => {
            if (this.language === 'en') {
              this.$message({
                message:
                  'The task was created successfully, please contact another administrator for approval!',
                type: 'success'
              })
            }
            if (this.language === 'zh_cn') {
              this.$message({
                message: '任务创建成功，请联系其他管理员审批!',
                type: 'success'
              })
            }
            if (this.language === 'zh_tw') {
              this.$message({
                message: '任務創建成功，請聯系其他管理員審批!',
                type: 'success'
              })
            }
            this.loading = false
            this.flagStr()
            this.back()
          })
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      }
    })
  }

  created () {}
}
